import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-16px font-semibold text-black-lp-300" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "text-16px font-semibold text-black-lp-300 pt-6" }
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "text-16px font-semibold text-black-lp-300 pt-6" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = {
  key: 0,
  class: "w-full bg-gradient-to-t from-gray-lp-700 absolute bottom-0 pb-6 flex justify-center items-center",
  style: {"padding-top":"8rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutCard = _resolveComponent("LayoutCard")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `${
        _ctx.isLoadMore ? 'overflow-auto' : 'overflow-hidden'
      } flex-grow space-y-3 pb-32`
    
    }, [
      _createVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("dashboard.console.allStt.incomingStt")), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_LayoutCard, {
          data: _ctx.incomingReceivedConsoleData,
          backgroundColor: "bg-green-lp-500",
          iconColor: "text-green-lp-400"
        }, null, 8, ["data"]),
        _createVNode(_component_LayoutCard, {
          data: _ctx.incomingNotFinishedConsoleData,
          backgroundColor: "bg-green-lp-500",
          iconColor: "text-green-lp-400"
        }, null, 8, ["data"])
      ]),
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.console.allStt.transitStt")), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_LayoutCard, {
          data: _ctx.transitUndeliveredConsoleData,
          backgroundColor: "bg-yellow-lp-400",
          iconColor: "text-yellow-lp-500"
        }, null, 8, ["data"]),
        _createVNode(_component_LayoutCard, {
          data: _ctx.transitUnfinishedConsoleData,
          backgroundColor: "bg-yellow-lp-400",
          iconColor: "text-yellow-lp-500"
        }, null, 8, ["data"])
      ]),
      _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.console.allStt.outgoingStt")), 1),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_LayoutCard, {
          data: _ctx.outgoingReceivedConsoleData,
          backgroundColor: "bg-red-lp-1100",
          iconColor: "text-red-lp-100"
        }, null, 8, ["data"]),
        _createVNode(_component_LayoutCard, {
          data: _ctx.outgoingNotFinishedConsoleData,
          backgroundColor: "bg-red-lp-1100",
          iconColor: "text-red-lp-100"
        }, null, 8, ["data"])
      ])
    ], 2),
    (!_ctx.isLoadMore)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_LpButton, {
            title: _ctx.$t('dashboard.console.allStt.loadMore'),
            textColor: "white",
            rounded: "",
            fontWeight: "semibold",
            textSize: 14,
            onClick: _ctx.onLoadMore
          }, null, 8, ["title", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}